import type {
  GetQueryInvalidateKeysProps,
  QueryInvalidateTarget,
} from "./query-invalidate.type";
import type { QueryKey } from "@tanstack/react-query";

export const getQueryInvalidateKeys = ({
  invalidate: customInvalidate,
  defaultInvalidate,
}: GetQueryInvalidateKeysProps) => {
  const backgroundKeys: QueryKey[] = [];
  const awaitedKeys: QueryKey[] = [];

  const invalidate: QueryInvalidateTarget[] =
    customInvalidate === undefined
      ? (defaultInvalidate ?? [])
      : (customInvalidate ?? []);

  invalidate.forEach((target) => {
    const queryKey: QueryKey = "mode" in target ? target.queryKey : target;
    const isAwaited = "mode" in target && target.mode === "awaited";
    isAwaited ? awaitedKeys.push(queryKey) : backgroundKeys.push(queryKey);
  });

  return {
    backgroundKeys,
    awaitedKeys,
  };
};
